var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_572_881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2429 10.7628C18.2429 12.9177 17.3869 14.9843 15.8632 16.5081C14.3394 18.0318 12.2728 18.8878 10.1179 18.8878C7.96304 18.8878 5.89641 18.0318 4.37268 16.5081C2.84894 14.9843 1.99292 12.9177 1.99292 10.7628C1.99292 8.60793 2.84894 6.54131 4.37268 5.01757C5.89641 3.49384 7.96304 2.63782 10.1179 2.63782C12.2728 2.63782 14.3394 3.49384 15.8632 5.01757C17.3869 6.54131 18.2429 8.60793 18.2429 10.7628ZM0.11792 10.7628C0.11792 13.415 1.17149 15.9585 3.04685 17.8339C4.92222 19.7092 7.46575 20.7628 10.1179 20.7628C12.7701 20.7628 15.3136 19.7092 17.189 17.8339C19.0644 15.9585 20.1179 13.415 20.1179 10.7628C20.1179 8.11065 19.0644 5.56711 17.189 3.69175C15.3136 1.81639 12.7701 0.762817 10.1179 0.762817C7.46575 0.762817 4.92222 1.81639 3.04685 3.69175C1.17149 5.56711 0.11792 8.11065 0.11792 10.7628ZM9.18042 5.45032V10.7628C9.18042 11.0753 9.33667 11.3683 9.59839 11.5441L13.3484 14.0441C13.7781 14.3331 14.3601 14.2159 14.6492 13.7823C14.9382 13.3488 14.821 12.7706 14.3875 12.4816L11.0554 10.2628V5.45032C11.0554 4.93079 10.6375 4.51282 10.1179 4.51282C9.59839 4.51282 9.18042 4.93079 9.18042 5.45032Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_572_881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.11792 0.762817)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockRegular);
export default __webpack_public_path__ + "static/media/clock-regular.61833e41bed24e3a695f1e679e19a30e.svg";
export { ForwardRef as ReactComponent };